<div class="flex flex-col gap-[8px]">
  <!-- 模块切换器：任务整体 + 各模块（仅当多于一个入口时显示） -->
  @if (options.length > 1) {
    <div class="flex flex-wrap gap-[8px]">
      @for (opt of options; track opt.moduleId; let i = $index) {
        <nz-tag [nzMode]="'checkable'" [nzChecked]="i === activeIndex" (nzCheckedChange)="onSelect(i)">{{
          opt.label
        }}</nz-tag>
      }
    </div>
  }

  <!-- 消息流：空态与列表同高，避免首次发送后块高跳动 -->
  <div class="h-[360px]">
    @if (activeThreadQuery) {
      <fl-message-list
        [threadQuery]="activeThreadQuery"
        [refreshTick]="refreshTick"
        (avatarClick)="onAvatarClick($event)"
        (threadOpened)="onThreadOpened($event)"
      ></fl-message-list>
    } @else {
      <div class="flex h-full items-center justify-center text-neutral-n4">暂无反馈</div>
    }
  </div>

  <!-- 底部回复区：文档流，消息流下方，常驻显示输入框 -->
  <div class="shrink-0">
    <fl-reply-composer
      [replyTarget]="replyTarget"
      [clearTick]="clearTick"
      [quote]="{}"
      [upload]="{ scope: 'blackboard', extra: { taskId: $safeNavigationMigration(task()?.id) } }"
      (send)="onSendReply($event)"
      (cancel)="onCancelReply()"
    >
      <!-- 「同步全班」勾选：由宿主通过插槽注入并自持状态。回复全班时恒勾选，仅作提示
           （CreateMessageBody 无 toAll 字段，本就必须全班可见）。
           不用 disabled/pointer-events-none：前者把蓝色勾选置灰，后者点击穿透会让输入框失焦收起 -->
      <label
        class="flex select-none items-center gap-[6px] text-[13px] text-neutral-n2"
        [class.cursor-pointer]="!!replyTarget?.msgId"
        [class.cursor-not-allowed]="!replyTarget?.msgId"
        (mousedown)="$event.preventDefault()"
        (click)="onToAllClick($event)"
        toAll
      >
        <input
          type="checkbox"
          name="replyToAll"
          [ngModel]="replyTarget?.msgId ? toAll : true"
          (ngModelChange)="toAll = $event"
          class="accent-[var(--color-primary-b1)]"
        />
        同步全班
      </label>
    </fl-reply-composer>
  </div>
</div>
